import { type PatientSurveyHistoryItem } from 'types/surveys';

export const getMatchedAnswers = (
  test: PatientSurveyHistoryItem
): { question: string; answers: string[] }[] => {
  const { survey, answers } = test;
  const questions = survey?.questions;
  if (!questions?.length || !answers?.length) return [];
  const questionsById = new Map(questions.map(question => [question.id, question]));
  const optionsByQuestionId = new Map(
    questions.map(question => [
      question.id,
      new Map(question.optionsDTO.map(option => [option.id, option.text])),
    ])
  );
  const result: { question: string; answers: string[] }[] = [];
  for (const answer of answers) {
    const question = questionsById.get(answer.questionId);
    if (!question?.text) continue;

    const optionTexts = optionsByQuestionId.get(question.id);
    const answerTexts = answer.optionIds.map(optionId => optionTexts?.get(optionId) ?? '');

    if (answerTexts.length === 0) continue;
    result.push({ question: question.text, answers: answerTexts });
  }
  return result;
};
